import React from "react";
var __jsx = React.createElement;
import { Skeleton } from "@/components/skeleton";

/** Skeleton placeholder for the tasks panel while the patient's reminders load. */
export function TasksSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6",
    role: "status",
    "aria-busy": "true"
  }, [0, 1].map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section,
      className: "flex flex-col gap-2"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-3 w-24"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-3 rounded-sds-300 border border-sds-base-default p-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-5 w-32 rounded-sds-full"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-5 w-20 rounded-sds-full"
    })), /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-4 w-40"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-3 w-28"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: "h-3 w-24"
    }))));
  }));
}